import previousQuoteStyles from './previous-quote';

// JW:2021-07-08 - ADO:4838 - Inline helpers to prevent load order issues
var helpers = {
  validateEmail: function validateEmail (email) {
    var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return re.test(String(email).toLowerCase());
  }
}
if (document.querySelector('.previous-quote-component')) {
  var emailAddy = document.querySelector(".previous-quote-component #emailAddress");
  var quoteNum = document.querySelector(".previous-quote-component #quoteNumber");
  var emailFieldContainer = document.getElementById('previous-quote__email-field-container');
  var quoteFieldContainer = document.getElementById('previous-quote__quote-id-field-container');
  setSubmitBtnState();
  if(emailAddy){
    addEventListeners();
    function addEventListeners() {
      emailAddy.addEventListener('keyup', validateEmailOnKeyup); quoteNum.addEventListener('keyup', validateQuoteNumberOnKeyUp); emailAddy.addEventListener('blur', validateEmail); quoteNum.addEventListener('blur', validateQuoteNumber); emailAddy.addEventListener('paste', validateEmailOnPaste); quoteNum.addEventListener('paste', validateQuoteNumberOnPaste); quoteNum.addEventListener('keypress', validateNumberOnKeyPress);
    }
  }
  function validateNumberOnKeyPress(obj){
    if([46,8,9,27,13].indexOf(obj.keyCode) !== -1 ||
      (obj.keyCode == 65 && obj.ctrlKey) ||
      (obj.keyCode == 67  && obj.ctrlKey) ||
      (obj.keyCode == 88  && obj.ctrlKey) ||
      (obj.keyCode >= 35  && obj.keyCode <= 39)) {
      return;
    }
    if((obj.shiftKey || (obj.keyCode < 48 || obj.keyCode > 57))){
      obj.preventDefault();
    }
  }
  function validateQuoteNumberOnKeyUp(obj) {
    if (obj.target.value) {
      quoteFieldContainer.classList.remove('show-error')
    }
    setSubmitBtnState()
  }
  function validateQuoteNumber(obj) {
    if (!obj.target.value) {
      quoteFieldContainer.classList.add('show-error')
    }
  }
  function validateQuoteNumberOnPaste(obj) {
    setTimeout(() => {
      validateQuoteNumberOnKeyUp(obj);
    }, (500));
  }
  function validateEmailOnKeyup(obj) {
    if (helpers.validateEmail(obj.target.value)) {
      emailFieldContainer.classList.remove('show-error')
    }
    setSubmitBtnState()
  }
  function validateEmail(obj) {
    if (!helpers.validateEmail(obj.target.value)) {
      emailFieldContainer.classList.add('show-error')
    }
  }
  function validateEmailOnPaste(obj) {
    setTimeout(() => {
      validateEmailOnKeyup(obj);
    }, (500));
  }
  function setSubmitBtnState() {
    let submitBtn = document.getElementById("previous-quote__submit-btn");
    if(submitBtn && emailAddy){
      let valid = helpers.validateEmail(emailAddy.value) && quoteNum.value;
      submitBtn.disabled = !valid;
      $('#previous-quote-generic-error').remove();
    }
  }
  $("#previous-quote__form").submit(function (e) {
  $("#previous-quote__submit-btn").attr("disabled", true);
  $('#previous-quote-generic-error').remove();
  var isSuccess = true;
  $.ajax({
    type: "GET",
    url: "/api/PODS/QuoteStatus?quoteId=" + $("#quoteNumber").val(),
    async: false,
    success: function (data, textStatus, jqXHR) {
      if (jqXHR.status == "200" && data == "Quote Found") {
        $("#previous-quote__form").attr("action", newBookingFlowUrl + "?action=retrieve");
      } else if (jqXHR.status == "200" && data == "IF Quote Found") {
        $("#previous-quote__form").attr("action", newIFBookingFlowUrl + "?action=retrieve");
      } else if (jqXHR.status == "200" ) {
        window.location.href = data;
        isSuccess = false;
      } else {
        isSuccess = false;
          let quoteStatusMessage = jqXHR.getResponseHeader('X-QuoteStatus-Message');
          let errorDiv = undefined;
          if (quoteStatusMessage) {
              errorDiv = $('#previous-quote-error-' + quoteStatusMessage);
              $('#previous-quote-error-' + quoteStatusMessage).show();
          }
          if (errorDiv && errorDiv.length) {
              errorDiv.show();
          }
          else {
              $("#previous-quote__submit-btn").after('<div id="previous-quote-generic-error" class="col-12 previous-quote__error form-error-message text-center">No quote found</div>');
          }
        }
      },
      error: function(jqXHR, textStatus, errorThrown){
        isSuccess = false;
        $("#previous-quote__submit-btn").after('<div id="previous-quote-generic-error" class="col-12 previous-quote__error form-error-message text-center">No quote found</div>');
      }
    });
    return isSuccess;
  });
  /*RB:2023-05-16 - check quote number in query string to continue to booking flow */
  const digits_only = string => [...string].every(c => '0123456789'.includes(c));
  $(document).ready(function () {
    var qn = $("#quoteNumber").val();
    if (qn.length > 0 && digits_only(qn)) {
      $("#previous-quote__form").submit();
    }
  });
}
